/**
 * Query keys for React Query cache management
 * Organized by feature/domain
 */
export const QUERY_KEYS = {
  // Authentication
  USER_PROFILE: 'userProfile',
  
  // Opportunities
  OPPORTUNITIES: 'opportunities',
  OPPORTUNITY_DETAILS: 'opportunityDetails',
  CALENDAR_VIEW: 'calendarView',
  GEOGRAPHIC_VIEW: 'geographicView',
  TRENDING_OPPORTUNITIES: 'trendingOpportunities',

  // Watchlist
  WATCHLIST: 'watchlist',

  // Messaging
  THREADS: 'threads',
  MESSAGES: 'messages',
  PLATFORM_USERS: 'platformUsers',
  
  // WebSocket and Real-time
  TYPING: 'typing',
  USER_STATUS: 'userStatus',
  
  // Events and Notifications
  EVENT_NOTIFICATIONS: 'eventNotifications',
  ALL_EVENTS: 'allEvents',
  
  // Analytics and Engagement
  ANALYTICS_SUMMARY: 'analyticsSummary',
  ENGAGEMENT_METRICS: 'engagementMetrics',
  ENGAGEMENT_LIST: 'engagementList',
  
  // Lookups and References
  LOOKUPS: 'lookups',
  SECTORS: 'sectors',
  STRATEGIES: 'strategies',
  GEOGRAPHIES: 'geographies',
  CURRENCIES: 'currencies',
  
  // User Preferences
  USER_PREFERENCES: 'userPreferences',
  
  // File Management
  ATTACHMENTS: 'attachments',
  FILE_COLLECTIONS: 'fileCollections',
  SAVED_FILES: 'savedFiles',
  
  // Settings & Preferences
  PREFERENCES: 'preferences',
  ALERTS: 'alerts',
  
  // Manager Engagement
  AUTH_USER: 'authUser',
  AUTH_STATUS: 'authStatus'
};

export default QUERY_KEYS; 